import { TableCell, TableRow, Typography } from "@mui/material";
import { useState } from "react";
import TableActions from "src/common/TableActions";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import { useApiMutation } from "src/hooks/useApiMutation";
import { getStatusLabel } from "src/Utils/Combined";
import { IFairStallList } from "src/Utils/type";
import UpdateStall from "./CreateFairStall/UpdateStall";

type IProps = {
	stall: IFairStallList;
	serial: number;
};

const FairStallTableRow = ({ stall, serial }: IProps) => {
	const [showModal, setShowModal] = useState<boolean>(false);

	const { mutate: deleteStall } = useApiMutation<void, void>({
		method: "DELETE",
		endPoint: `/api/fair/stall/${stall.fair_stall_id}`,
		invalidateQueries: ["FairStalls"],
	});

	return (
		<>
			<TableRow hover key={stall.fair_stall_id}>
				<TableCell>
					<Typography
						variant='body1'
						color='text.primary'
						gutterBottom
						noWrap
					>
						{serial}
					</Typography>
				</TableCell>
				<TableCell>
					<Typography
						variant='body1'
						color='text.primary'
						gutterBottom
						noWrap
					>
						{stall.fair_stall_hall_name}
					</Typography>
				</TableCell>
				<TableCell>
					<Typography
						variant='body1'
						color='text.primary'
						gutterBottom
						noWrap
					>
						{stall.fair_stall_type}
					</Typography>
				</TableCell>
				<TableCell>
					<Typography
						variant='body1'
						color='text.primary'
						gutterBottom
						noWrap
					>
						{stall.stall_no}
					</Typography>
				</TableCell>

				<TableCell>
					{getStatusLabel(stall.fair_stall_available_status)}
				</TableCell>
				<TableActions
					showDelete
					showEdit
					showView
					viewLink={`/fair/stall/${stall.fair_stall_id}`}
					handleDeleteFun={deleteStall}
					handleEditFun={() => setShowModal(true)}
				/>
			</TableRow>
			<ModalsWrapper
				showModal={showModal}
				setShowModal={setShowModal}
				modalData={{ title: `Update Stall: ${stall.stall_no}` }}
			>
				<UpdateStall
					handleClose={() => setShowModal(false)}
					defaultValues={stall}
				/>
			</ModalsWrapper>
		</>
	);
};

export default FairStallTableRow;
